import React from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png"

export default function Contact() {
  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}
            <section
        className="relative py-28 bg-cover bg-center"
        style={{
          backgroundImage: `url(${hearderbg})`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white animate-fadeUp">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
           Contact Us
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
             We’re here to help you grow your business with BINGOPAY.
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="relative py-24">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12">

          {/* CONTACT INFO */}
          <div className="glass rounded-3xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold mb-8 text-indigo-600">
              Contact Information
            </h2>

            <div className="space-y-6 text-gray-700">

              {/* Open Hours */}
              <div>
                <p className="font-semibold text-gray-900">🕒 Open Hours</p>
                <p className="text-sm mt-1">
                  Mon – Sun<br />
                  9:00 AM – 10:00 PM
                </p>
              </div>

              {/* Registered Address */}
              <div>
                <p className="font-semibold text-gray-900">
                  🏢 Registered Address
                </p>
                <p className="text-sm mt-1">
                  # 879/13, Kurukshetra,<br />
                  Haryana – 136118
                </p>
              </div>

              {/* Corporate Address */}
              <div>
                <p className="font-semibold text-gray-900">
                  🏬 Corporate Address
                </p>
                <p className="text-sm mt-1">
                  # Shop No. 1490-B,<br />
                  Rani Bagh Delhi,<br />
                  Delhi– 110034
                </p>
              </div>

              {/* Phone */}
              <div>
                <p className="font-semibold text-gray-900">📞 Phone</p>
                <p className="text-sm mt-1">
                  +91 8586 036 036
                </p>
              </div>

              {/* Email */}
              <div>
                <p className="font-semibold text-gray-900">📧 Email</p>
                <p className="text-sm mt-1">
                  info@bingopays.in
                </p>
              </div>

            </div>
          </div>

          {/* CONTACT FORM */}
          <div className="glass rounded-3xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold mb-6 text-indigo-600">
              Send Us a Message
            </h2>

            <form className="space-y-5">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full rounded-xl p-4 bg-white/70 border border-white/40
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />

              <input
                type="email"
                placeholder="Your Email"
                className="w-full rounded-xl p-4 bg-white/70 border border-white/40
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />

              <textarea
                rows="5"
                placeholder="Your Message"
                className="w-full rounded-xl p-4 bg-white/70 border border-white/40
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-indigo-600 to-cyan-500
                text-white py-4 rounded-xl font-semibold
                hover:scale-[1.03] transition-transform duration-300"
              >
                Send Message
              </button>
            </form>
          </div>

        </div>
      </section>

    </div>
  );
}
